import { render, staticRenderFns } from "./nothing-but-a-router-view.vue?vue&type=template&id=b3aa229a&"
import script from "./nothing-but-a-router-view.vue?vue&type=script&lang=ts&"
export * from "./nothing-but-a-router-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports